import { useState } from "react";
import { Accordion, Card } from "react-bootstrap";

import NewReport from "pages/common/Analytics/components/Reports/NewReport";
import Reports from "pages/shipper/Analytics/components/Reports";
import { ReactComponent as SortIcon } from "assets/images/icons/SortDown.svg";
import { useQueryClient } from "@tanstack/react-query";

import "./Analytics.scss";
import { FormattedMessage } from "react-intl";

const Analytics = function () {
  const [activeKey, setActiveKey] = useState<string>("1");
  const queryClient = useQueryClient();

  // Callback function to be called when a new report is created
  const onNewReportSuccess = () => {
    closeAccordion();
    queryClient.invalidateQueries({ queryKey: ["report-list"], exact: false });
  };

  const closeAccordion = () => setActiveKey("1");

  return (
    <>
      {/* Create Report Table */}
      <Accordion activeKey={activeKey} defaultActiveKey="0" onSelect={(eventKey) => setActiveKey(eventKey || "1")}>
        <Accordion.Toggle as={Card.Header} eventKey="0" className={`accordion-header ${activeKey === "0" && "active"}`}>
          <h3>
            <FormattedMessage id="report.createReport" defaultMessage="Create Report" />
          </h3>
          <SortIcon fill="#000" width={8} height={7} transform={`rotate(${activeKey === "0" ? 180 : 0})`} />
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="0">
          <NewReport onSuccess={onNewReportSuccess} onCancel={closeAccordion} />
        </Accordion.Collapse>
      </Accordion>

      {/* Generated Reports Table */}
      <Reports showTitle />
    </>
  );
};

export default Analytics;
